import React from 'react';
import styled from 'styled-components';

import {
  CPAAS_TERMS_URL,
  JAAS_TERMS_URL,
  MOBILE_THRESHOLD,
  PRIVACY_POLICY_URL,
  TERMS_OF_SERVICE_LINK,
} from '~/core/constants';
import { isVpaaS } from '~/services/auth0';
import { translate } from '~/services/translate';

const Container = styled.div`
  font-size: 11px;
  text-align: center;
  line-height: 20px;
  color: ${({ theme }) => theme.lightGray};

  @media screen and (max-width: ${MOBILE_THRESHOLD}px) {
    line-height: 48px;
  }
`;

const StyledAnchor = styled.a`
  color: ${({ theme }) => theme.lightGray};
`;

export default () => isVpaaS() ? (
  <Container>
    {translate('terms_and_conditions_apply_vpaas_1')}
    <StyledAnchor
      href={CPAAS_TERMS_URL}
      target="_blank"
      rel="noopener noreferrer"
    >
      {translate('cpaas_terms')}
    </StyledAnchor>
    {translate('and')}
    <br />
    <StyledAnchor
      href={JAAS_TERMS_URL}
      target="_blank"
      rel="noopener noreferrer"
    >
      {translate('jaas_module')}
    </StyledAnchor>
    ,{translate('terms_and_conditions_apply_vpaas_2')}
    <StyledAnchor
      href={PRIVACY_POLICY_URL}
      target="_blank"
      rel="noopener noreferrer"
    >
      {translate('privacy_policy')}
    </StyledAnchor>
  </Container>
) : (
  <Container>
    {translate('terms_and_conditions_apply')}
    <StyledAnchor
      href={TERMS_OF_SERVICE_LINK}
      target="_blank"
      rel="noopener noreferrer"
    >
      {translate('terms_and_conditions_apply_link_text')}
    </StyledAnchor>
  </Container>
);
